module.exports = __webpack_public_path__ + "img/undraw_Confirmation_re_b6q5.d0246ef2.svg";